import Vue from 'vue';
import TYPES from '@/types';

// Domain
import { WealthFlexibleDepositStateManager } from '@/modules/my-investment/allianz/transaction/domain/state/wealth-flexible-deposit-state-manager';
import Translator from '@/modules/shared/domain/i18n/translator';
import { Values } from '@/modules/shared/domain/i18n/types';
import Inject from '@/modules/shared/domain/di/inject';

export default class AllianzDepositFlexibleResultViewModel {
  @Inject(TYPES.I18N)
  readonly translator!: Translator;

  @Inject(TYPES.WEALTH_FLEXIBLE_DEPOSIT_STATE_MANAGER)
  readonly wealth_flexible_deposit_state_manager!: WealthFlexibleDepositStateManager;

  private readonly view: Vue;

  i18n_namespace = 'components.allianz-dashboard.deposits.flexible_deposit_result';

  translate = (message: string, values?: Values) => this.translator.translate(`${this.i18n_namespace}.${message}`, values);

  public constructor(view: Vue) {
    this.view = view;
  }

  continue() {
    this.view.$emit('endProcess');
  }
}
